import { render } from "./LocationForm.vue?vue&type=template&id=0aa81de0&scoped=true"
import script from "./LocationForm.vue?vue&type=script&lang=ts"
export * from "./LocationForm.vue?vue&type=script&lang=ts"

import "./LocationForm.vue?vue&type=style&index=0&id=0aa81de0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0aa81de0"

export default script